import { Snackbar, SnackbarProps } from '@material-ui/core'
import { AlertTitle as MuiAlertTitle } from '@material-ui/lab'
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

import { IAlertProps, ISnackBarProps } from './SnackBarComponenet.types'

const alertColor = (severity: string) => {
  switch (severity) {
    case 'success':
      return colors.green
    case 'warning':
      return colors.warning
    case 'error':
      return colors.red
    default:
      return colors.blue
  }
}

function Alert(props: AlertProps) {
  return (
    <MuiAlert
      elevation={6}
      {...props}
      style={{ borderLeft: `5px solid ${alertColor(props.severity)}` }}
    />
  )
}

function AlertTitle(props: AlertProps) {
  return (
    <MuiAlertTitle style={{ color: alertColor(props.severity) }}>
      {props.children}
    </MuiAlertTitle>
  )
}

export const Container = styled(Snackbar)<ISnackBarProps & SnackbarProps>``
export const Content = styled(Alert)<IAlertProps>``
export const StyledAlertTitle = styled(AlertTitle)``
